import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { GridLoader } from 'react-spinners';
import Header from '../component/layout/header';
import PageHeader from '../component/layout/pageheader';
import FooterSection from '../component/layout/footer';
import FilterSearchSection from '../component/section/filtersearch';
import WidgetGroupSection from '../component/section/widgetgroup';
import CommentSection from '../component/section/comments';
import CommentRespond from '../component/section/commentrespond';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper';
import "swiper/css";
import "swiper/css/navigation";

const StoryDetails = () => {
    const { id } = useParams();
    const [story, setStory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [groupList, setGroupList] = useState([]);
    const [loadingGroups, setLoadingGroups] = useState(true);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        fetchStory();
        getLatestGroups();
    }, [id]);

    const getLatestGroups = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_MAIN_SITE_URL}/latest-groups`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            setGroupList(res.data.data);
            setLoadingGroups(false);
        } catch (error) {
            console.error("Failed to fetch top groups:", error);
            setLoadingGroups(false);
        }
    };

    const fetchStory = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_MAIN_SITE_URL}/story/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            if (res.data && res.data.data) {
                setStory(res.data.data);
                if (res.data.data.comments) {
                    setComments(res.data.data.comments);
                }
            }
            setLoading(false);
        } catch (error) {
            console.error("Failed to fetch story details:", error);
            setLoading(false);
        }
    };

    const handleCommentAdded = (newComment) => {
        if (newComment && newComment.id) {
            setComments((prev) => [newComment, ...prev]);
        } else {
            // Re-fetch story to get updated comments if backend doesn't return the full new comment
            fetchStory();
        }
    };

    if (loading) {
        return (
            <div>
                <Header />
                <PageHeader title={'Story Details'} />
                <div style={{ display: 'flex', justifyContent: 'center', margin: '100px 0' }}>
                    <GridLoader color="#f50057" />
                </div>
                <FooterSection />
            </div>
        );
    }

    if (!story) {
        return (
            <div>
                <Header />
                <PageHeader title={'Story Details'} />
                <div className="container" style={{ textAlign: 'center', margin: '100px 0' }}>
                    <h3>Story not found!</h3>
                    <Link to="/stories" className="lab-btn mt-3">Back to Stories</Link>
                </div>
                <FooterSection />
            </div>
        );
    }

    return (
        <div>
            <Header />
            <PageHeader title={story.title ? story.title.replace(/<[^>]+>/g, '') : ''} />
            <section className="blog-section padding-tb pb-lg-110">
                <div className="container">
                    <div className="main-blog">
                        <div className="row">
                            <div className="col-lg-8 col-12">
                                <div className="blog-wrapper">
                                    <div className="post-item">
                                        <div className="post-item-inner">
                                            {story.youtube_link && (
                                                <div className="post-thumb">
                                                    <div className="embed-responsive">
                                                        <iframe
                                                            width="100%"
                                                            height="400"
                                                            src={`https://www.youtube.com/embed/${story.youtube_link.split("v=")[1]?.split("&")[0] || story.youtube_link.split("/").pop()}`}
                                                            title="YouTube video player"
                                                            frameBorder="0"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                            allowFullScreen
                                                        ></iframe>
                                                    </div>
                                                </div>
                                            )}

                                            {!story.youtube_link && story.images && story.images.length > 0 && (
                                                <div className="post-thumb">
                                                    <Swiper
                                                        spaceBetween={10}
                                                        centeredSlides
                                                        autoplay={{
                                                            delay: 4000,
                                                            disableOnInteraction: false,
                                                        }}
                                                        navigation={{
                                                            prevEl: ".blog-slider-prev",
                                                            nextEl: ".blog-slider-next",
                                                        }}
                                                        loop={story.images.length > 1}
                                                        modules={[Autoplay, Navigation]}
                                                        className="mySwiper"
                                                    >
                                                        {story.images.map((imgUrl, i) => (
                                                            <SwiperSlide key={i}>
                                                                <img
                                                                    src={imgUrl}
                                                                    alt={`story-${story.id}-${i}`}
                                                                    style={{ width: "100%", borderRadius: "10px" }}
                                                                />
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                </div>
                                            )}

                                            <div className="post-content mt-4">
                                                <span className="meta d-flex align-items-center mb-3">
                                                    {story.user?.profile_image && (
                                                        <img src={story.user.profile_image} alt={story.user.name} style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }} />
                                                    )}
                                                    <span>By <Link to="#">{story.user?.name || 'Admin'}</Link> · {new Date(story.created_at).toLocaleDateString()}</span>
                                                </span>
                                                <h3 dangerouslySetInnerHTML={{ __html: story.title }}></h3>
                                                
                                                <div className="mt-4" dangerouslySetInnerHTML={{ __html: story.description }}></div>
                                            </div>
                                        </div>
                                    </div>
                                    <CommentSection comments={comments} />
                                    <CommentRespond storyId={id} onCommentAdded={handleCommentAdded} />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12">
                                <aside className="mt-5 mt-lg-0">
                                    <FilterSearchSection />
                                    <WidgetGroupSection 
                                        groupList={groupList}
                                        loading={loadingGroups}
                                    />
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <FooterSection />
        </div>
    );
};

export default StoryDetails;